export default "__VITE_ASSET__CPhD_5Ck__"